import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import './JaapaSettings.css';

const divineNames = [
  { value: 'Jai Shree Krishna', key: 'jaiShreeKrishna' },
  { value: 'Jai Shree Ram', key: 'jaiShreeRam' },
  { value: 'Om Namaha Shivaya', key: 'omNamahaShivaya' },
  { value: 'Shree Radha', key: 'shreeRadha' },
  { value: 'Sita Ram', key: 'sitaRam' },
  { value: 'Om Gan Ganapataye Namah', key: 'omGanGanapatayeNamah' },
  { value: 'Om Rudraya Namah', key: 'omRudrayaNamah' },
  { value: 'Radhe Krishna', key: 'radheKrishna' },
  { value: 'Om Sai Ram', key: 'omSaiRam' },
  { value: 'Shreem', key: 'shreem' },
  {
    value: 'Hare Krishna Hare Krishna\nKrishna Krishna Hare Hare\nHare Rama Hare Rama\nRama Rama Hare Hare',
    key: 'hareKrishnaMahaMantra',
  },
];

const JaapaSettings = ({ selectedName, onNameChange }) => {
  const { t } = useLanguage();

  return (
    <div className="jaapa-settings">
      <label htmlFor="divine-name-select">{t('bhaktiJaapaPage.settings.chooseDivineName')}</label>
      <select 
        id="divine-name-select"
        value={selectedName}
        onChange={(e) => onNameChange(e.target.value)}
      >
        {divineNames.map((nameOption) => (
          <option key={nameOption.value} value={nameOption.value}>
            {t(`bhaktiJaapaPage.divineNames.${nameOption.key}`, {}, nameOption.value)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default JaapaSettings;
